module.exports = __webpack_public_path__ + "static/img/saleicon1.438b098.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/saleicon1.png
// module id = Gc1M
// module chunks = 2